import { createStationBreadcrumbItem } from '@app/components/base/stations/StationBreadcrumbLabel';
import { Page } from '@app/components/page/Page';
import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { ComposeIcon } from '@app/modules/compose/components/ComposeIcon';
import { EnrichedCompositionDetailDto } from '@app/modules/compose/composition.types';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { BreadcrumbItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export interface ComposeSocialExportUploadBreadcrumbsProps {
  composition: EnrichedCompositionDetailDto;
}

/**
 * Breadcrumb trail for the composition social upload page. Extends the composition view trail
 * (module root + station) with the composition itself, linked back to its view page.
 */
export function ComposeSocialExportUploadBreadcrumbs({
  composition,
}: ComposeSocialExportUploadBreadcrumbsProps) {
  const { $t } = useIntl();
  const findStation = useStationsFinder();
  // Compositions may have no station assigned, in which case the trail skips that level.
  const station = composition.stationId ? findStation(composition.stationId) : null;

  const items: BreadcrumbItem[] = [
    {
      icon: <ComposeIcon fontSize="inherit" />,
      content: $t({
        id: 'compose.listScreen.hubLabel',
        defaultMessage: 'Compose',
      }),
    },
    ...(station
      ? [
          createStationBreadcrumbItem(
            station,
            composeRouteGenerator.listForStationSlug(station.slug),
          ),
        ]
      : []),
    {
      content: composition.name,
      href: composeRouteGenerator.view(composition.id),
    },
  ];

  return <Page.Breadcrumbs items={items} />;
}
